/** @format */
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { tenantPaymentMethodServices } from '../../../../Services/tenantPaymentMethod.service';
import CardsTable from './CardsTable';
import { lettersOnly } from '../../../../Config/Regex';

const AddPaymentMethod = ({ show, setShow, onHide, setResultModal, data }) => {
	const { t: translator } = useTranslation();
	const [selectedCards, setSelectedCards] = useState(data.creditCardIds);
	const [fiscalTagValue, setFiscalTagValue] = useState(data.fiscalTag);

	const { handleSubmit, errors, register } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});
	console.log(data);

	const onSubmit = submitData => {
		tenantPaymentMethodServices
			.updatePaymentMethod(data.tenantPaymentMethodId, {
				paymentMethodId: data.paymentMethodId,
				name: submitData.name,
				tag: submitData.tag,
				fiscalTag: submitData.fiscalTag,
				useFiscalization: submitData.useFiscalization,
				creditCardIds: selectedCards,
				isDefault: submitData.isDefault,
			})
			.then(res => {
				onHide();
				setResultModal({
					show: true,
					title: translator('CardTypes-AssignPaymentMethod-SuccesModal-Title'),
					text: translator(res.data.message),
					btnClass: 'btn btn-primary',
				});
			})
			.catch(err => console.log(err));
	};

	return (
		<Modal
			show={show}
			onHide={() => {
				setShow(false);
			}}
			size='lg'
			centered>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{translator('TenantPaymentMethod-EditTitle')}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<fieldset className='scheduler-border'>
						<div className='row'>
							<div className='col-lg-6'>
								<legend className='scheduler-border mb-3 '>
									{translator('TenantPaymentMethod-Cards')}
								</legend>

								<div className='form-group'>
									<label htmlFor='ddlStore'>
										{translator('PaymentMethod-Name')}
									</label>
									<input
										className='form-control'
										type='text'
										name='name'
										disabled={!data.tenantId}
										defaultValue={data.paymentMethodName}
										ref={register({
											required: true,
											pattern: lettersOnly,
											maxLength: 20,
										})}
									/>
									{errors.name && errors.name.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
									{errors.name && errors.name.type === 'pattern' && (
										<p className='text-danger'>
											{translator('ValidationMsg-LettersOnly')}
										</p>
									)}
									{errors.name && errors.name.type === 'maxLength' && (
										<p className='text-danger'>
											{translator('ValidationMsg-MaxLength20')}
										</p>
									)}
								</div>
								<div className='form-group'>
									<label htmlFor='ddlStore'>
										{translator('PaymentMethod-Tag')}
									</label>
									<input
										className='form-control'
										type='text'
										name='tag'
										disabled={!data.tenantId}
										defaultValue={data.tag}
										ref={register({
											required: true,
											maxLength: 1,
										})}
									/>
									{errors.tag && errors.tag.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
									{errors.tag && errors.tag.type === 'maxLength' && (
										<p className='text-danger'>
											{translator('ValidationMsg-MaxLength1')}
										</p>
									)}
								</div>

								<div className='form-group'>
									<label htmlFor='ddlStore'>
										{translator('PaymentMethod-FiscalTag')}
									</label>
									<select
										className='form-control'
										name='fiscalTag'
										aria-label='Default select example'
										disabled={!data.tenantId}
										defaultValue={data.fiscalTag}
										ref={register({ required: true })}
										onChange={e => {
											setFiscalTagValue(e.target.value);
											setSelectedCards([]);
										}}>
										<option>G</option>
										<option>K</option>
										<option>T</option>
										<option>O</option>
									</select>
									{errors.fiscalTag && errors.fiscalTag.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
								</div>

								<div className='form-group'>
									<label className='labelCont'>
										<input
											ref={register}
											type='checkbox'
											name='useFiscalization'
											disabled={!data.tenantId}
											defaultChecked={data.useFiscalization}
										/>
										<span className='checkmark'></span>
									</label>
									<span className='Data'>
										{translator('AddTenantPaymentMethod-UseFiscalization')}
									</span>{' '}
									{/* <Tooltip text={translator('Users-PriceEditing-Msg')} /> */}
								</div>
								<div className='form-group'>
									<label className='labelCont'>
										<input
											ref={register}
											type='checkbox'
											name='isDefault'
											defaultChecked={data.isDefault}
										/>
										<span className='checkmark'></span>
									</label>
									<span className='Data'>
										{translator('AddTenantPaymentMethod-IsDefault')}
									</span>{' '}
									{/* <Tooltip text={translator('Users-PriceEditing-Msg')} /> */}
								</div>
							</div>
							<div className='col-lg-6'>
								{fiscalTagValue === 'K' && data.tenantId && (
									<CardsTable
										selectedItems={selectedCards}
										setSelectedItems={setSelectedCards}
									/>
								)}
							</div>
						</div>
					</fieldset>
				</Modal.Body>

				<Modal.Footer>
					<Button
						variant='secondary'
						onClick={() => {
							setShow(false);
						}}>
						{translator('Btn-Cancel')}
					</Button>
					<button className='btn btn-primary' type='submit'>
						{translator('Btn-Save')}
					</button>
				</Modal.Footer>
			</form>
		</Modal>
	);
};

export default AddPaymentMethod;
